module.exports = __webpack_public_path__ + "b80caeebb90fabab3513de850951aa63.png";